import {
  INVALID_TOKEN,
  VALID_TOKEN,
  OPEN_ERROR_BOX,
  SET_SESSION_ID,
} from "./../constants/actionTypes.js";
import { defaultAction } from "./../actions/defaultAction";

export const checkToken =
  (token) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const data = await remote(
        "put",
        "/v3/customers/password/check-token",
        { token },
        "creating checking a token",
        dispatch
      );

      if (data.message) {
        throw data;
      }

      dispatch(defaultAction(VALID_TOKEN, token));
    } catch (e) {
      dispatch(defaultAction(INVALID_TOKEN));
    }
  };

export const resetPassword =
  (password, token) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const reset = await remote(
        "put",
        "/v3/customers/password/reset",
        { token, password },
        "creating a password",
        dispatch
      );

      if (reset.message) {
        throw reset;
      }

      history.push("/confirm-reset-pass");
    } catch (e) {
      dispatch(
        defaultAction(OPEN_ERROR_BOX, {
          title: "Sorry, we are experiencing technical difficulties",
          message:
            "We are sorry. There was a problem connecting to the server. Please try again. If you are still having issues, please reach out to support@cardcash.com. Thank you.",
        })
      );
    }
  };
